module.exports = __webpack_public_path__ + "static/img/public@2x.2823a005.png";